(() => {
  const normalize = value => value.normalize('NFKC').toLowerCase().trim();
  function init(scope = document) {
    scope.querySelectorAll('[data-collection-search]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const root = form.closest('[data-collection-search-root]');
      const input = form.querySelector('input');
      const clear = form.querySelector('[type="reset"]');
      const status = root.querySelector('[data-collection-search-status]');
      const grid = root.querySelector('.catalog-grid');
      const sort = root.querySelector('.sort-form');
      const pages = root.querySelector('.pagination');
      let original = grid.innerHTML;
      root.addEventListener('featured:ready', event => { original = event.detail.html; });
      let products, controller, generation = 0;
      function reset() {
        generation++; controller?.abort();
        grid.innerHTML = original; status.textContent = ''; clear.hidden = true;
        if (sort) sort.hidden = false;
        if (pages) pages.hidden = false;
        grid.removeAttribute('aria-busy');
      }
      form.addEventListener('reset', reset);
      input.addEventListener('input', () => { if (!input.value.trim()) reset(); });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const query = normalize(input.value);
        if (!query) { reset(); return; }
        const current = ++generation;
        controller?.abort(); controller = new AbortController();
        const signal = controller.signal;
        clear.hidden = false; status.textContent = 'Searching…'; grid.setAttribute('aria-busy', 'true');
        try {
          if (!products) {
            const loaded = [], seen = new Set();
            let url = new URL(form.dataset.source, location.origin);
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            while (url) {
              url.searchParams.set('view', 'search-data');
              if (preview) url.searchParams.set('preview_theme_id', preview);
              if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid pagination');
              seen.add(url.href);
              const response = await fetch(url, {signal, credentials: 'same-origin'});
              if (!response.ok) throw new Error('Request failed');
              const data = await response.json();
              if (!Array.isArray(data.products)) throw new Error('Invalid response');
              loaded.push(...data.products);
              url = data.next ? new URL(data.next, url) : null;
            }
            if (current !== generation) return;
            products = loaded;
          }
          if (current !== generation) return;
          const words = query.split(/\s+/);
          const matches = products.filter(product => words.every(word => normalize(product.keywords).includes(word)));
          grid.innerHTML = matches.map(product => product.html).join('');
          if (sort) sort.hidden = true;
          if (pages) pages.hidden = true;
          status.textContent = matches.length ? `${matches.length} products found for “${input.value.trim()}”` : 'No matching products. Try another part number, name or system.';
        } catch (error) {
          if (error.name !== 'AbortError' && current === generation) status.textContent = 'Unable to search. Please try again.';
        } finally {
          if (current === generation) grid.removeAttribute('aria-busy');
        }
      });
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
